import api from '@/services/gateway/api';

const baseUrl = 'camp/superapp-feedback';
const JSON_HEADERS = { headers: { 'Content-Type': 'application/json' } };

export default {
  namespaced: true,
  state: {
    list: [],
    meta: { current_page: 1, per_page: 20, total: 0, last_page: 1, new_count: 0 },
    item: null,
    dictionaries: { types: [], statuses: [], priorities: [], categories: [], features: [] }
  },
  getters: {
    getList: state => state.list,
    getMeta: state => state.meta,
    getItem: state => state.item,
    getDictionaries: state => state.dictionaries
  },
  mutations: {
    setList (state, list) {
      state.list = list;
    },
    setMeta (state, meta) {
      state.meta = meta;
    },
    setItem (state, item) {
      state.item = item;
    },
    setDictionaries (state, dictionaries) {
      state.dictionaries = dictionaries;
    }
  },
  actions: {
    actionGetDictionaries ({ commit }) {
      return api.get(`${baseUrl}/dictionaries`).then(({ data }) => {
        commit('setDictionaries', data.data);
        return data.data;
      });
    },
    actionGetList ({ commit }, { params, isLatest = () => true }) {
      return api.get(`${baseUrl}/tickets`, { params }).then(({ data }) => {
        if (isLatest()) {
          commit('setList', data.data);
          commit('setMeta', data.meta);
        }
        return data;
      });
    },
    actionGetItem ({ commit }, id) {
      commit('setItem', null);
      return api.get(`${baseUrl}/tickets/${id}`).then(({ data }) => {
        commit('setItem', data.data);
        return data.data;
      });
    },
    actionUpdate ({ commit }, { id, payload }) {
      return api.patch(`${baseUrl}/tickets/${id}`, payload, JSON_HEADERS).then(({ data }) => {
        commit('setItem', data.data);
        return data.data;
      });
    },
    actionExport (context, params) {
      return api.get(`${baseUrl}/tickets/export`, { params, responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'superapp-feedback.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    }
  }
};
